import { render } from "./HeaderComponent.vue?vue&type=template&id=0c89fc44"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=0c89fc44&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__